import styled from 'styled-components'
import { themeObject, textModels, shadow } from 'Pages/landings/newLandings/common/style'

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	background: ${themeObject.colors.base.white};
	${shadow('m')}
	border-radius: 16px;
	padding: 32px 40px;
`
export const Title = styled.p<{ titleStyle: string }>`
	${textModels('notAdaptive', 'xl', '600')}
	color: ${themeObject.colors.grey[800]};
	text-align: left;
	margin-bottom: 12px;
	order: 1;
	${({ titleStyle }) => titleStyle && titleStyle}
`
export const Text = styled.p<{ textStyle: string }>`
	${textModels('text', 'l')}
	color: ${themeObject.colors.grey[800]};
	text-align: left;
	order: 1;
	${({ textStyle }) => textStyle && textStyle}
`
